import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTollRatesApiMeta } from "../apiMeta";
import {
  type TollTripVersionInput,
  tollTripVersionInputSchema,
} from "./shared/tollTripVersion.input";
import {
  type TollTripVersion,
  tollTripVersionSchema,
} from "./shared/tollTripVersion.output";

/**
 * Metadata for the fetchTollTripVersion endpoint
 */
export const tollTripVersionMeta = {
  functionName: "fetchTollTripVersion",
  endpoint: "/getTollTripVersionAsJson",
  inputSchema: tollTripVersionInputSchema,
  outputSchema: tollTripVersionSchema,
  sampleParams: {},
  endpointDescription: "Get current version and timestamp for toll trip data.",
} satisfies EndpointMeta<TollTripVersionInput, TollTripVersion>;

/**
 * Fetch function for retrieving current version and timestamp for toll trip data
 */
const { fetch, useHook } = createFetchAndHook<
  TollTripVersionInput,
  TollTripVersion
>({
  api: wsdotTollRatesApiMeta,
  endpoint: tollTripVersionMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/tollTripVersion.endpoints").tollTripVersionGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving current version and timestamp for toll trip data
 */
export const fetchTollTripVersion: FetchFactory<
  TollTripVersionInput,
  TollTripVersion
> = fetch;

/**
 * React Query hook for retrieving current version and timestamp for toll trip data
 */
export const useTollTripVersion: HookFactory<
  TollTripVersionInput,
  TollTripVersion
> = useHook;
